import React from "react";

const ResetPin = ({ userId, onClose }) => {
  const handleConfirmReset = async () => {
    try {
      const response = await fetch(`/api/admin/reset-pin/${userId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ reset_pin: 1 }),
      });

      if (!response.ok) {
        throw new Error("Failed to reset PIN.");
      }

      alert("User PIN reset request has been submitted.");
      onClose(); // Close the modal after success
    } catch (error) {
      console.error("Error resetting PIN:", error);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>✖</button>
        <h3>Reset PIN</h3>
        <p>Are you sure you want to reset the PIN for this user?</p>
        <button onClick={handleConfirmReset} className="reset-button">Confirm Reset</button>
      </div>
    </div>
  );
};

export default ResetPin;
